{
  "pt": {
    "ticket_category": {
      "Decisions": "Decisões",
      "Issue": "Pós-Venda",
      "Other": "Outros",
      "labels": {
        "ticket_category": "Tipo"
      }
    }
  }
}
